import { useState } from 'react';
import { BatchHistoryTable } from '../components/BatchHistoryTable';
import { HistoricalTable } from '../components/HistoricalTable';
import { HistoryPageLayout, type HistoryTab } from '../../components/HistoryPageLayout';

export function MobileHistoryPage() {
  const [activeTab, setActiveTab] = useState<HistoryTab>('scan');

  return (
    <HistoryPageLayout activeTab={activeTab} onTabChange={setActiveTab}>
      {activeTab === 'scan' ? <HistoricalTable /> : <BatchHistoryTable />}
    </HistoryPageLayout>
  );
}
